module.exports = __webpack_public_path__ + "static/img/logo.8dfff7f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/logo.png
 ** module id = 3
 ** module chunks = 1
 **/